import { Typography } from "@mui/material";

import ROUTES from "@app/common/routes";
import type { User } from "@app/common/types";

import Link from "@rui/Link";

import { DisclaimerContainer } from "./styles";

const AutomaticShareDisclaimer = ({ user }: { user?: User | null }) => {
  if (!user) return null;

  return (
    <DisclaimerContainer>
      <Typography variant="bodySecondaryReg">
        You{" "}
        {user.internalParticipantAccessLevel !== "no_access" &&
        user.externalParticipantAccessLevel !== "no_access"
          ? ""
          : "do not "}
        automatically share the report with all participants.{" "}
        <Link href={ROUTES.USER_SETTINGS_REPORTING}>View settings</Link>
      </Typography>
    </DisclaimerContainer>
  );
};

export default AutomaticShareDisclaimer;
